import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {
    FETCH_FILTERS_REQUEST,
    FETCH_FILTERS_SUCCESS,
    FETCH_FILTERS_FAILURE,
    UPDATE_FILTER,
    SAVE_FILTERS_REQUEST,
    SAVE_FILTERS_SUCCESS,
    SAVE_FILTERS_FAILURE,
    RESET_DASHBOARD_FILTERS,
} from '../actions';

const initialState = {
    // district: null,
    // status: null,
    // allocated: null,
    // surgeryType: null,

    options: {
        districtFilterList: [],
        statusList: [],
        allocatedList: [],
        surgeryTypeList: [],
    },
    appliedFilters:{
        districtFilter: [],
        statusFilter: [],
        allocatedFilter: [],
        surgeryTypeFilter: [],
        defaultDate: null,
        // surgeryStartDate: null,
        // surgeryEndDate: null,
    },
    defaultFilters: {
        districtFilter: [],
        statusFilter: [],
        allocatedFilter: [],
        surgeryTypeFilter: [],
        defaultDate: null,
    },
    loading: false,
    error: null,
};

const dashboardFiltersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FILTERS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_FILTERS_SUCCESS: {
            const { options } = action.payload;
            // Extract default filter values (items with isDefault: true)
            const defaultFilters = {
                districtFilter: (options.districtFilterList || []).filter(item => item.isDefault).map(item => item.districtCode || item.districtName),
                statusFilter: (options.statusList || []).filter(item => item.isDefault).map(item => item.filterCode || item.filterName),
                allocatedFilter: (options.allocatedList || []).filter(item => item.isDefault).map(item => item.filterCode || item.filterName),
                surgeryTypeFilter: (options.surgeryTypeList || []).filter(item => item.isDefault).map(item => item.filterCode || item.filterName),
                defaultDate: options.defaultDate,
            };
            return {
                ...state,
                loading: false,
                options,
                defaultFilters,
                error: null,
            };
        }

        case FETCH_FILTERS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case UPDATE_FILTER: {
            // If no payload passed, reset to initial state
            const appliedFilters = action.payload || initialState.appliedFilters;
            return { ...state, appliedFilters };
        }

        case SAVE_FILTERS_REQUEST:
            return { ...state, loading: true, error: null };

        case SAVE_FILTERS_SUCCESS:
            return { ...state, loading: false };

        case SAVE_FILTERS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case RESET_DASHBOARD_FILTERS:
            return { ...state, options: initialState.options };

        default:
            return state;
    }
};

export default persistReducer(
    {
        key: 'dashboardFiltersKey',
        storage: storage,
    },
    dashboardFiltersReducer
);
